import { render, staticRenderFns } from "./OnboardingPayoutCard.vue?vue&type=template&id=66f78b00&"
import script from "./OnboardingPayoutCard.vue?vue&type=script&lang=js&"
export * from "./OnboardingPayoutCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports